import { cn } from "src/common/utils";

// Official Devin (Cognition) logo, sourced from devin.ai/icon.png. The PNG already
// includes its own dark background so we don't wrap it.
const DevinIcon = ({ className }: { className?: string }) => (
  <img src="/images/devin-logo.png" alt="Devin" className={cn(className, "object-contain")} />
);

export default DevinIcon;
